import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import {
    GetCustomerLogoApiResponseModel,
    SaveCustomerLogoApiResponseModel,
} from "@midland-industries/Types/CustomerLogosModels";
import { Draft } from "immer";

type CustomerLogosState = Readonly<{
    logoImageUrl: string;
    companyName: string;
    erpNumber: string;
    erpSequence: string;
    salespersonName: string;
    salespersonPhone: string;
    salespersonEmail: string;
    isLoading: boolean;
    isLoaded: boolean;
}>;

const initialState: CustomerLogosState = {
    logoImageUrl: "",
    companyName: "",
    erpNumber: "",
    erpSequence: "",
    salespersonName: "",
    salespersonEmail: "",
    salespersonPhone: "",
    isLoading: false,
    isLoaded: false,
};

const CustomerLogosData = createTypedReducerWithImmer(initialState, {
    "Custom/CustomerLogos/BeginLoad": (draft: Draft<CustomerLogosState>) => {
        draft.isLoading = true;
        draft.isLoaded = false;
    },
    "Custom/CustomerLogos/CompleteLoad": (
        draft: Draft<CustomerLogosState>,
        action: { result: GetCustomerLogoApiResponseModel },
    ) => {
        draft.logoImageUrl = action.result.imageUrl;
        draft.companyName = action.result.companyName;
        draft.erpNumber = action.result.erpNumber;
        draft.erpSequence = action.result.erpSequence;
        draft.salespersonName = action.result.salespersonName;
        draft.salespersonEmail = action.result.salespersonEmail;
        draft.salespersonPhone = action.result.salespersonPhone;
        draft.isLoading = false;
        draft.isLoaded = true;
    },
    "Custom/CustomerLogos/BeginSave": (draft: Draft<CustomerLogosState>) => {
        draft.isLoading = true;
        draft.isLoaded = false;
    },
    "Custom/CustomerLogos/CompleteSave": (
        draft: Draft<CustomerLogosState>,
        action: { result: SaveCustomerLogoApiResponseModel },
    ) => {
        draft.logoImageUrl = action.result.imageUrl;
        draft.isLoading = false;
        draft.isLoaded = true;
    },
    "Custom/CustomerLogos/CompleteDelete": (draft: Draft<CustomerLogosState>) => {
        draft.logoImageUrl = "";
        draft.isLoading = false;
        draft.isLoaded = true;
    },
});

export default (reducers as any).xcentiumCustomerLogos = CustomerLogosData;

export type CustomCustomerLogosState = {
    xcentiumCustomerLogos: CustomerLogosState;
} & ApplicationState;

type Reducers = {
    customerLogosReducer: typeof CustomerLogosData;
};

export type xcentiumCustomerLogosActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
